import Bloc from './Bloc.js';
import Types from './Types.js';

export default class FilterPlayFromSide extends Bloc {

	constructor (src, ctx) {

		super("filterplayfromside", src, ctx);
		this.f = (src, ins) => [card => (ins[0] ? card.fromLeft : card.fromRight)];
		this.types = [Types.bool];
	}
}